import React from "react";
import { styled } from "@mui/styles";

import {
    Box,
    Button as MuiIconButton
} from "@mui/material";
import {
    Add as AddIcon,
    Delete as DeleteIcon,
    Edit as EditIcon,
    Save as SaveIcon,
    ArrowDownward,
    ArrowUpward,
    Replay
} from "@mui/icons-material";

const IconButton = styled(MuiIconButton)({
    padding: '2px',
    marginTop: '-2px',
    marginLeft: '2px',
    minWidth: 0,
});

const AdminToolbar = ({ items, itemId, handleSetAdd, handleSetEdit, handleDelete, handleSave, handleMove, handleReset, changed, selectedItem, movable }) => {
    return (
        (<Box display="flex" justifyContent="space-between">
            <Box display="flex" justifyContent="flex-start">
                <IconButton
                    onClick={handleSetAdd}
                    disabled={items.filter(i => i.toEdit).length > 0}
                    size="large"><AddIcon /></IconButton>
                <IconButton onClick={handleSetEdit} disabled={!selectedItem} size="large"><EditIcon /></IconButton>
                <IconButton onClick={handleSave} disabled={!changed} size="large"><SaveIcon /></IconButton>
                <IconButton onClick={handleDelete} disabled={!selectedItem} size="large"><DeleteIcon /></IconButton>
            </Box>
            <Box display="flex" justifyContent="flex-end">
                <IconButton onClick={handleReset} disabled={!changed} size="large"><Replay /></IconButton>
                {movable &&
                    <React.Fragment>
                        <IconButton
                            onClick={() => handleMove(1)}
                            disabled={!selectedItem || items.slice(-1)[0][itemId] === selectedItem}
                            size="large"><ArrowDownward /></IconButton>
                        <IconButton
                            onClick={() => handleMove(-1)}
                            disabled={!selectedItem || items.slice(0, 1)[0][itemId] === selectedItem}
                            size="large"><ArrowUpward /></IconButton>
                    </React.Fragment>}
            </Box>
        </Box>)
    );
};

export default AdminToolbar;